<template>
	<div class="servicebox" v-html="detail.content">
	</div>
</template>

<script>
export default {
    name: 'serviceCenter',
    data () {
        return {
            msg: 'Welcome to Your Vue.js App',
            detail:[]
        }
    },
    mounted() {
        this.getConduct();
    },
    methods:{

        // 加载公司简介
        getConduct: async function () {
            const res = await this.$getJSON('/index/conduct');
            this.detail = res.data.detail;
        }
    }
}
</script>

<style scoped="">
	.servicebox{
		min-height: 182px;
		width: 1200px;
		margin: 80px auto;
		font-size: 20px;
	}
	.sertit{
		font-size: 40px;
		letter-spacing: 4px;
		line-height: 90px;
	}
	.sercont1{
		width: 600px;
		margin: 20px auto;
	}
</style>


// WEBPACK FOOTER //
// src/vew/serviceCenter.vue